import { UserPlus, Search, Upload, Cpu, FileText } from 'lucide-react';
import styles from './HowItWorks.module.css';

const STEPS = [
  {
    icon: <UserPlus size={24} />,
    title: "1. Sign In",
    desc: "Create a secure account to save your reports and track your PC health over time."
  },
  {
    icon: <Search size={24} />,
    title: "2. Choose Issue",
    desc: "Select the specific problem you're facing, from slow performance to blue screen crashes."
  },
  {
    icon: <Upload size={24} />,
    title: "3. Run Scanner",
    desc: "Run our safe, one-click scanner to gather system health data and upload the .pcc file."
  },
  {
    icon: <Cpu size={24} />,
    title: "4. AI Analysis",
    desc: "Our AI engine cross-references your logs with thousands of known issues to find the root cause."
  },
  {
    icon: <FileText size={24} />,
    title: "5. Get Report",
    desc: "Receive a plain-English health report with prioritized fixes and step-by-step instructions."
  }
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className={styles.section}>
      <div className="wrap">
        <div className="section-header">
          <div className="section-label">Process</div>
          <h2>How It Works</h2>
          <p>Go from a slow PC to a fixed PC in five simple steps.</p>
        </div>

        <div className={styles.steps}>
          {STEPS.map((step, index) => (
            <div key={index} className={styles.step}>
              <div className={styles.iconWrapper}>
                <div className={styles.icon}>{step.icon}</div>
                {index < STEPS.length - 1 && <div className={styles.line}></div>}
              </div>
              <div className={styles.content}>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
